import {Component, Input, OnInit} from '@angular/core';
import {ApiRestService} from "../_services/api-rest.service";
import {Smtp} from "../_models/smtp";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiPathsService} from "../../api-paths.service";
import {ClassicType} from "../../shared/models/ClassicType";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";

@Component({
  selector: 'app-smtp-edit',
  templateUrl: './smtp-edit.component.html'
})
export class SmtpEditComponent implements OnInit {
  @Input() item: Smtp;
  Tipi: ClassicType[];
  Tipo: ClassicType;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    singleOutput: true,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'label',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: false,
    allowRemoteDataSearch: true,
  };

  constructor(
    private apiRestService: ApiRestService,
    private modalService: NgbActiveModal,
    private apiPath: ApiPathsService,
    ) { }

  ngOnInit(): void {
    this.apiPath.ClassicGet('/smtp/tipi').subscribe(data=>{
      this.Tipi = data.data;
    })
  }
  save(){
    this.item.tipo = this.Tipo?.id;
    if(this.item?.id)
      this.apiRestService.UpdateSmtp(this.item).subscribe(data=> this.modalService.dismiss());
    else
      this.apiRestService.AddSmtp(this.item).subscribe(data=> this.modalService.dismiss());
  }

  cancelClick() {
    this.modalService.dismiss();
  }
}
